// extracted by mini-css-extract-plugin
export default {"cls1":"StepContent_cls1__nm4o5","cls2":"StepContent_cls2__Qsjzz StepContent_cls1__nm4o5"};